export const BYTES_FRACTION = 1024;

export const bytesToGb = (bytes: number) => bytes / BYTES_FRACTION / BYTES_FRACTION / BYTES_FRACTION;
